import clsx from 'clsx';
import { FC, useCallback, useEffect } from 'react';
import { useModalContext } from 'state/contexts/modalContext/modalContext';
import { ModalType } from 'state/contexts/modalContext/types';
import { Styles } from 'types/styles';

type Props = {
  closeModal: () => void;
  width: number | string;
  className: string;
  isModalOpen: boolean;
  newStyles?: Styles;
};
const Modal: FC<Props> = ({
  closeModal,
  width,
  className,
  isModalOpen,
  children,
  newStyles = {},
}) => {
  const { modal } = useModalContext();

  const excludeClickOutsideModalsArray = [ModalType.MODAL_CHECK_EMAIL_MESSAGE];

  const shouldExcludeClickOutside = excludeClickOutsideModalsArray.includes(
    modal.modalType,
  );

  const stopPropagationCallback = useCallback((e) => {
    e.stopPropagation();
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', (event) => {
      if (event.keyCode === 27) closeModal();
    });

    return () => document.removeEventListener('keydown', closeModal);
  }, [closeModal]);

  return (
    <div
      className={clsx(newStyles['modal-backdrop-wrapper'], {
        [newStyles.open]: isModalOpen,
        [newStyles[className]]: newStyles[className],
      })}
      role="button"
      tabIndex={0}
      onClick={shouldExcludeClickOutside ? undefined : closeModal}
    >
      <div className={newStyles['modal-scroll-container']}>
        <div className={newStyles['modal-wrapper']} style={{ maxWidth: width }}>
          <div className={newStyles.modal} onClick={stopPropagationCallback}>
            {isModalOpen && children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
